import { combineReducers } from 'redux'
import Map from './map'
import User from './user'

export default combineReducers({
    Map,
    User
})
